export default "__VITE_ASSET__iZ5Xd4fa__"